import { motion } from "framer-motion";

export default function Methodology() {
  return (
    <section
      data-testid="methodology"
      className="mx-auto max-w-[1400px] px-6 py-28 md:px-16 md:py-36"
    >
      <div className="grid grid-cols-1 gap-10 border-t border-white/10 pt-16 md:grid-cols-12">
        <div className="md:col-span-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="mb-4 font-display text-2xl font-600 italic text-[#CBFF3A]"
          >
            The Methodology
          </motion.h2>
          <span className="font-hud text-[11px] uppercase tracking-[0.25em] text-white/40">
            Strategy × Craft
          </span>
        </div>

        <div className="md:col-span-8">
          <motion.p
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
            className="font-display text-2xl font-400 leading-snug text-[#ECEAE3] md:text-4xl md:leading-[1.25]"
          >
            I blend the precision of a{" "}
            <span className="italic text-[#CBFF3A]">creative marketer</span> with
            the soul of a{" "}
            <span className="italic text-[#CBFF3A]">filmmaker</span> to deliver
            narratives that cut through the noise.
          </motion.p>
        </div>
      </div>
    </section>
  );
}
